import { useEffect } from 'react';

import Container from 'react-bootstrap/Container';
import { Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { Header } from './layout/Header';

import { Login } from './Login';
import { PrivateRoutes } from './PrivateRoutes';

import { checkLoggedIn } from './userSlice';

export function Admin() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkLoggedIn());
  }, [dispatch]);

  return (
    <>
      <Header />
      <Container className="mt-3" fluid>
        <Switch>
          <Route exact path="/admin/login">
            <Login />
          </Route>
          <Route>
            <PrivateRoutes />
          </Route>
        </Switch>
      </Container>
    </>
  );
}
